import { configurationApi } from "~/api";
import type { StatusCode } from "~/types/api";

export const createListRequest = async (workflowId: number, name: string) => {
  return await configurationApi.client.POST("/api/workflow/{workflowId}/List", {
    params: { path: { workflowId } },
    body: { name },
  });
};

export const updateListNameRequest = async (workflowId: number, listId: number, name: string) => {
  return await configurationApi.client.PATCH("/api/workflow/{workflowId}/List/{listId}/name", {
    params: { path: { workflowId, listId } },
    body: { name },
  });
};

export const updateListStatusesRequest = async (
  workflowId: number,
  listId: number,
  statusCodes: StatusCode[]
) => {
  return await configurationApi.client.PUT("/api/workflow/{workflowId}/list/{listId}/status", {
    params: { path: { workflowId, listId } },
    body: [...statusCodes],
  });
};

export const deleteListRequest = async (workflowId: number, listId: number) => {
  return await configurationApi.client.DELETE("/api/workflow/{workflowId}/List/{listId}", {
    params: { path: { workflowId, listId } },
  });
};
